/**
 *  ÓRAADÓ (megbízási jogviszonyú, óradíjas kolléga) – a kiszolgáló backend/oraado.js párja,
 *  a kettő maradjon azonos.
 *
 *  Óraadónál CSAK A MEGTARTOTT ÓRÁK számítanak (Európa 2000, 2026-10-06): nincs kötött
 *  munkaidő és nincs munkaidő-arány (reszm_arany) – helyette a szerződés szerinti heti
 *  óraszám (heti_oraszam) áll, a díj megtartott órák × óradíj.
 *
 *  Óraadó, akinek a jogviszonya (allomany_feladatellatas.munkaviszony) megbízás:
 *  'megbizas' (a tárolt érték), '7' (az adatlap régi „Óraadó – megbízás” opciója),
 *  '6' („Polgári – megbízás”).
 */
export const ORAADO_JOGVISZONYOK: readonly string[] = ['megbizas', '7', '6'];

/** Az adatlap jogviszony-választójában az óraadó értéke. */
export const ORAADO_JOGVISZONY = 'megbizas';

/** Óraadó-e a jogviszony-érték (allomany_feladatellatas.munkaviszony)? */
export function oraadoJogviszony(munkaviszony: any): boolean {
  if (munkaviszony == null) return false;
  return ORAADO_JOGVISZONYOK.includes(String(munkaviszony).trim().toLowerCase());
}

/** A szerződés szerinti heti óraszám (szám vagy null). */
export function hetiOraszam(ertek: any): number | null {
  if (ertek == null || ertek === '') return null;
  const n = Number(String(ertek).replace(',', '.'));
  return Number.isFinite(n) && n > 0 ? n : null;
}
